$(function() {
    $('.ata-link').click(function(e) {
        e.preventDefault();

        if ($('#ata').hasClass('ata-open')) {
            $('#ata').fadeOut(500);
        } else {
            $('#ata').fadeIn(500);
        }

        $('#ata').toggleClass('ata-open');

    });

    $('.ata-link').hover(function() {
        // $('#ata').addClass('turn-up');
        // $('#ata').fadeIn(500);
    }, 
    function() {
        // $('#ata').removeClass('turn-up');
        // $('#ata').fadeOut(500);
    });
});